import React from "react";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="max-w-3xl">
        <div className="overline">Our story</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 tracking-tighter leading-[1.05]">
          A heritage stitched in every print.
        </h1>
      </div>

      <div className="grid md:grid-cols-2 gap-12 md:gap-20 mt-16 items-start">
        <div className="aspect-[4/5] overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_ankara-vibes/artifacts/mdadajsn_IMG-20260606-WA0020%20%281%29.jpg"
            alt="cindymaks story"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div>
          <p className="text-lg leading-relaxed text-brand-muted">
            cindymaks Collections is the work of one designer who believes Ankara fabric tells a story too rich to be reduced to a trend. Every piece begins as a length of cloth chosen for its rhythm of color and pattern, then cut to honor the body that will wear it.
          </p>
          <p className="text-lg leading-relaxed text-brand-muted mt-6">
            We work in small batches. We finish by hand. We name each silhouette so it carries its own identity into your wardrobe. The result is clothing made to be worn often, kept long, and passed on.
          </p>
          <p className="text-lg leading-relaxed text-brand-muted mt-6">
            Thank you for being here — and for wearing the story.
          </p>
          <div className="font-serif text-2xl mt-10">— Cindy</div>

          <Link to="/shop" data-testid="about-shop-btn" className="btn-primary mt-12">Shop the collection</Link>
        </div>
      </div>
    </div>
  );
}
